import * as Types from '../generated/types';

import { gql } from '@apollo/client';
export type MeNodeFragment = { __typename?: 'MeNode', id: string, username: string, firstName?: string | null, lastName?: string | null, email?: string | null, isReadOnly: boolean, lastLogin?: any | null, isSuperuser: boolean, userPermissions?: Array<string | null> | null, dateJoined?: any | null };

export const MeNodeFragmentDoc = gql`
    fragment MeNode on MeNode {
  id
  username
  firstName
  lastName
  email
  isReadOnly
  lastLogin
  isSuperuser
  userPermissions
  dateJoined
}
    `;